import * as types from './types'

import webApi from '../api'

export const Signin = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.signin(data)
      .then((response) => {
        commit(types.AUTH, {
          loggedInAt: new Date(),
          ...response.data
        })
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const Register = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.register(data)
      .then((response) => {
        commit(types.AUTH, {
          loggedInAt: new Date(),
          ...response.data
        })
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetFeaturedProductsData = ({ commit }, locationId) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getFeaturedProductsData(locationId)
      .then((response) => {
        commit(types.GENERAL_SETTINGS, response.data.kf_resources)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        reject(error.response.data)
      })
  })
  return promise
}

export const ListMenu = ({ commit }, locationId) => {
  const promise = new Promise((resolve, reject) => {
    webApi.listMenu(locationId)
      .then((response) => {
        commit(types.GENERAL_SETTINGS, response.data.kf_resources)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const ListLunchBoxes = ({ commit }, locationId) => {
  const promise = new Promise((resolve, reject) => {
    webApi.listLunchBoxes(locationId)
      .then((response) => {
        commit(types.GENERAL_SETTINGS, response.data.kf_resources)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const ManageCustomerInCheckout = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.manageCustomerInCheckout(data)
      .then((response) => {
        if (!data.guest) {
          commit(types.AUTH, {
            loggedInAt: new Date(),
            ...response.data
          })
        }
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const PlaceOrder = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.placeOrder(data)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetOrder = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    webApi.getOrder(data)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

export const AuthSignout = ({ commit }) => {
  commit(types.SIGNOUT)
}

export const SetLocation = ({ commit }, payload) => {
  commit(types.LOCATION, payload)
}

export const UpdateCart = ({ commit }, payload) => {
  commit(types.UPDATE_CART, payload)
}

export const UpdateOrderType = ({ commit }, orderType) => {
  commit(types.ORDER_TYPE, orderType)
}

export const GetStatus = ({ commit }) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getStatus()
      .then((response) => {
        commit(types.STATUS, response.data)
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetSettings = ({ commit }, locationId) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getSettings(locationId)
      .then((response) => {
        commit(types.GENERAL_SETTINGS, response.data)
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const EditCustomer = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.editCustomer(data)
      .then((response) => {
        commit(types.STATUS, response.data)
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetCustomerPaymentSources = ({ commit }, locationId) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getCustomerPaymentSources(locationId)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const DeleteCustomerDefaultPaymentSource = ({ commit }, locationId) => {
  const promise = new Promise((resolve, reject) => {
    webApi.deleteCustomerDefaultPaymentSource(locationId)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetCustomerOrders = ({ commit }) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getCustomerOrders()
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetDiscount = ({ commit }, code) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getDiscount(code)
      .then((response) => {
        commit(types.DISCOUNT, response.data)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const RestorePassword = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.restorePassword(data)
      .then(() => {
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const GetCustomerByPasswordToken = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.getCustomerByPasswordToken(data)
      .then((response) => {
        resolve(response.data.customer)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const SetNewPassword = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.setNewPassword(data)
      .then(() => {
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const UpdateDiscount = ({ commit }, discount) => {
  let nullDiscount = {
    code: null,
    amount: null,
    type: null
  }

  if (discount) {
    commit(types.DISCOUNT, discount)
  } else {
    commit(types.DISCOUNT, nullDiscount)
  }
}

export const SendMessage = ({ commit }, data) => {
  const promise = new Promise((resolve, reject) => {
    webApi.sendMessage(data)
      .then(() => {
        resolve()
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
  return promise
}

export const LoadingOn = ({ commit }) => {
  commit(types.LOADING_ON)
}
export const LoadingOff = ({ commit }) => {
  commit(types.LOADING_OFF)
}



// WEBPACK FOOTER //
// ./src/store/actions.js